import { atom } from 'jotai'

export const showParcelLayer = atom(true)
